<template>
  <div
    v-if="typeof call.call !== 'undefined'"
    class="flex items-center justify-between w-full px-4 border rounded"
    :class="statusClass"
  >
    <div class="flex justify-between flex-grow">
      <div class="flex flex-col">
        <div>Number: {{ call.call?.attributes.number }}</div>
        <div class="text-xs text-gray-500">
          Ref: #{{ call.call?.id }}
        </div>
        <!-- <div>Queue: Test Camapign: Test</div> -->
      </div>
      <div class="flex flex-col justify-between text-right">
        <div class="text-xs font-medium text-gray-500">
          {{ call.status }}
        </div>
        <div class="text-xs text-gray-400">
          ({{ duration }})
        </div>
      </div>
    </div>
    <div class="flex items-center">
      <button
        v-if="call.status !== 'TERMINATED' && call.status !== 'PRECONNECT'"
        title="Hangup Call"
        class="p-2 ml-2 bg-red-100 rounded-full"
        @click="hangup"
      >
        <ld-icon
          class="w-4 h-4"
          icon="PhoneMissedCallIcon"
        />
      </button>
      <button
        v-if="showCallFunctions"
        title="Hold Call"
        class="p-2 ml-2 bg-orange-100 rounded-full"
        @click="call.status === 'ON_HOLD' ? unHold() : hold()"
      >
        <ld-icon
          class="w-4 h-4"
          :icon="call.status === 'ON_HOLD' ? 'PlayIcon' : 'PauseIcon'"
        />
      </button>
      <Popover class="relative">
        <PopoverButton
          v-if="showCallFunctions"
          title="Keypad"
          class="p-2 ml-2 bg-teal-100 rounded-full"
        >
          <ld-icon
            title="Dial Pad"
            class="w-4 h-4"
            icon="ViewGridIcon"
          />
        </PopoverButton>
        <transition
          enter-active-class="transition duration-200 ease-out"
          enter-from-class="translate-y-1 opacity-0"
          enter-to-class="translate-y-0 opacity-100"
          leave-active-class="transition duration-150 ease-in"
          leave-from-class="translate-y-0 opacity-100"
          leave-to-class="translate-y-1 opacity-0"
        >
          <PopoverPanel
            class="absolute z-10 w-screen max-w-xs px-2 mt-3 transform -translate-x-1/2 left-1/2 sm:px-0"
          >
            <div
              class="overflow-hidden rounded-lg shadow-lg ring-1 ring-black/5"
            >
              <div class="relative grid grid-cols-3 gap-1 px-5 py-6 bg-white">
                <button
                  class="px-2 py-4 rounded-full bg-teal hover:bg-teal-100"
                  @click="dtmf('1')"
                >
                  1
                </button>
                <button
                  class="px-2 py-4 rounded-full bg-teal hover:bg-teal-100"
                  @click="dtmf('2')"
                >
                  2
                </button>
                <button
                  class="px-2 py-4 rounded-full bg-teal hover:bg-teal-100"
                  @click="dtmf('3')"
                >
                  3
                </button>
                <button
                  class="px-2 py-4 rounded-full bg-teal hover:bg-teal-100"
                  @click="dtmf('4')"
                >
                  4
                </button>
                <button
                  class="px-2 py-4 rounded-full bg-teal hover:bg-teal-100"
                  @click="dtmf('5')"
                >
                  5
                </button>
                <button
                  class="px-2 py-4 rounded-full bg-teal hover:bg-teal-100"
                  @click="dtmf('6')"
                >
                  6
                </button>
                <button
                  class="px-2 py-4 rounded-full bg-teal hover:bg-teal-100"
                  @click="dtmf('7')"
                >
                  7
                </button>
                <button
                  class="px-2 py-4 rounded-full bg-teal hover:bg-teal-100"
                  @click="dtmf('8')"
                >
                  8
                </button>
                <button
                  class="px-2 py-4 rounded-full bg-teal hover:bg-teal-100"
                  @click="dtmf('9')"
                >
                  9
                </button>
                <button
                  class="px-2 py-4 rounded-full bg-teal hover:bg-teal-100"
                  @click="dtmf('*')"
                >
                  *
                </button>
                <button
                  class="px-2 py-4 rounded-full bg-teal hover:bg-teal-100"
                  @click="dtmf('0')"
                >
                  0
                </button>
                <button
                  class="px-2 py-4 rounded-full bg-teal hover:bg-teal-100"
                  @click="dtmf('#')"
                >
                  #
                </button>
              </div>
            </div>
          </PopoverPanel>
        </transition>
      </Popover>
      <button
        v-if="showCallFunctions && allowConference"
        title="Conference In User"
        class="p-2 ml-2 bg-teal-100 rounded-full"
        @click="conferenceTransferModal = true"
      >
        <ld-icon
          class="w-4 h-4"
          icon="UserAddIcon"
        />
      </button>
      <button
        v-if="showCallFunctions && allowConference"
        title="Conference in another number"
        class="p-2 ml-2 bg-teal-100 rounded-full"
        @click="openConferenceInNumber = true"
      >
        <ld-icon
          class="w-4 h-4"
          icon="PlusIcon"
        />
      </button>
      <button
        v-if="showCallFunctions && allowTransfers"
        title="Transfer call"
        class="px-2 py-1 ml-2 bg-teal-100 rounded-full"
        @click="transferModal = true"
      >
        <font-awesome-icon
          class="text-teal-900 fa-md"
          icon="share"
        />
      </button>
    </div>
    <conference-in-number-modal
      v-if="openConferenceInNumber"
      :open="openConferenceInNumber"
      @close="openConferenceInNumber = false"
    />
    <TransferModal
      v-if="transferModal"
      :open="transferModal"
      @close="transferModal = false"
    />
    <TransferModal
      v-if="conferenceTransferModal"
      :open="conferenceTransferModal"
      :conferenced="true"
      @close="conferenceTransferModal = false"
    />
  </div>
</template>

<script setup lang="ts">
import { CallStatusTypes } from '@letsdial/phone/src/lib/types'
import { DateTime } from 'luxon'
import { Popover, PopoverButton, PopoverPanel } from '@headlessui/vue'
import {
  computed,
  defineComponent,
  onMounted,
  onUnmounted,
  Ref,
  ref,
  watch,
} from 'vue'
import ConferenceInNumberModal from '/@/components/ui/modals/ConferenceInNumberModal.vue'
import TransferModal from '/@/components/ui/modals/TransferModal.vue'
import useLetsDialPhone from '/@/services/letsDialPhone/useLetsDialPhone'
import useLetsDialSocket from '/@/services/letsDialSocket/useLetsDialSocket'
import { useCallStore } from '/@/store/callStore'
import { useRecordStore } from '/@/store/recordStore'
import { Campaign } from '@letsdial/api/src/lib/types/Campaign'
import { Organization } from '@letsdial/api/src/lib/types/Organization'
import useLetsDialAPI from '/@/services/letsDialAPI/useLetsDialAPI'
import { useAuthStore } from '/@/store/authStore'
import { CallEndedBy } from '@letsdial/api/src'

const duration = ref('')

let timeInterval: any
const call = useCallStore()
const api = useLetsDialAPI()
const openConferenceInNumber = ref(false)
const transferModal = ref(false)
const conferenceTransferModal = ref(false)
const { phone } = useLetsDialPhone()
const { socket } = useLetsDialSocket()
const recordStore = useRecordStore()
const authStore = useAuthStore()
const campaign: Ref<Campaign | undefined> = ref(undefined)
const organization: Ref<Organization | undefined> = ref(undefined)
const clearCall = () => {
  call.$reset()
  authStore.setAvailabilityStatus('IDLE')
}
watch(call, (newCall) => {
  console.log(!newCall.onCall, !call.error, newCall.call)
  if (
    newCall.status === CallStatusTypes.TERMINATED &&
    newCall.call?.id &&
    !call.error &&
    !call.hasDispositions &&
    !call.conferenced
  ) {
    clearCall()
  }
})
const statusClass = computed(() => {
  switch (call.status) {
    case CallStatusTypes.ANSWERED:
      return 'bg-teal-50 border-teal-200'
    case CallStatusTypes.INITIATING:
    case CallStatusTypes.RINGING:
      return 'bg-blue-50 border-blue-200'
    case CallStatusTypes.TERMINATED:
      return 'bg-red-50 border-red-200'
    default:
      return 'bg-gray-50 border-gray-200'
  }
})
const showCallFunctions = computed(
  () =>
    call.status === CallStatusTypes.ANSWERED ||
    call.status === CallStatusTypes.ON_HOLD,
)

const hangup = async () => {
  if (call.call?.id) {
    await api.calls.patch(call.call.id, {
      id: call.call.id,
      type: 'calls',
      attributes: {
        callEndedBy: CallEndedBy.USER,
      },
    })
  }
  phone.hangup()
}
const hold = () => {
  phone.hold()
}
const unHold = () => {
  phone.unHold()
}
const dtmf = (tone: string) => {
  phone.sendDtmf(tone)
}
onMounted(async () => {
  console.log(recordStore.pop, call.incomingCall)
  if (recordStore.pop?.campaignID) {
    campaign.value =
      (await api.campaigns.get(recordStore.pop.campaignID)).data ?? undefined
  }
  if (call.call?.relationships?.campaign?.data?.id) {
    campaign.value =
      (await api.campaigns.get(call.call?.relationships?.campaign?.data?.id))
        .data ?? undefined
  }
  if (authStore.selectedOrganization?.id) {
    try {
      organization.value =
        (await api.organizations.get(authStore.selectedOrganization.id)).data ??
        undefined
    } catch (e) {
      console.error(e)
    }
  }
  timeInterval = setInterval(() => {
    if (call.statusChangedAt) {
      const diff = DateTime.now().diff(call.statusChangedAt)
      duration.value = diff.toFormat('hh:mm:ss')
    }
  }, 1000)
})
onUnmounted(() => {
  clearInterval(timeInterval)
})

const allowConference = computed(() => {
  if (campaign.value) {
    return campaign.value.attributes.additionalConfig?.allowConferencedTransfers
  }
  if (organization.value) {
    return organization.value.attributes.additionalConfig?.allowConferencedTransfers
  }
  return true
})
const allowTransfers = computed(() => {
  if (campaign.value) {
    return (
      campaign.value.attributes.additionalConfig?.allowTransferToQueues ||
      (campaign.value.attributes.additionalConfig?.externalTransferNumbers ?? [])
        .length > 0 ||
      campaign.value.attributes.allowTransferToTeamLeader ||
      campaign.value.attributes.allowTransferToTeamMembers
    )
  }
  if (organization.value) {
    const config = organization.value.attributes.additionalConfig
    return (
      config?.allowTransferToQueues ||
      (config?.externalTransferNumbers ?? []).length > 0 ||
      config?.allowTransferToTeamLeader ||
      config?.allowTransferToTeamMembers
    )
  }
  return true
})
</script>
